export function HammerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      className="hammerIcon"
    >
      <path
        d="M17.1377 6.90007C17.2689 7.02837 17.4875 7.02837 17.6186 6.90007L17.9247 6.6007C18.0558 6.4724 18.0558 6.25857 17.9247 6.13027L12.9844 1.34037C12.8533 1.21207 12.6347 1.21207 12.5035 1.34037L12.1975 1.59697C12.0663 1.72527 12.0663 1.9391 12.1975 2.0674C12.8096 2.66614 16.6131 6.42963 17.1377 6.90007Z"
        fill="white"
      />
      <path
        d="M4.93972 18.1049H12.3282V17.5062C12.3282 16.8219 11.7599 16.2231 11.0167 16.2231H6.20757C5.50806 16.2231 4.896 16.7791 4.896 17.5062V18.1049H4.93972Z"
        fill="white"
      />
      <path
        d="M18.5367 4.84726C18.7553 4.63343 18.7553 4.33406 18.5367 4.12022L14.9954 0.660376C14.7768 0.446541 14.4708 0.446541 14.2522 0.660376L13.6401 1.25911L17.8809 5.40751L18.5367 4.85154V4.84726Z"
        fill="white"
      />
      <path
        d="M16.394 6.94283C15.9131 6.47239 12.6342 3.26487 12.1533 2.79443L8.65576 6.21579L12.8965 10.3642L16.394 6.94283Z"
        fill="white"
      />
      <path
        d="M10.0553 12.46C10.1427 12.5456 10.2739 12.5883 10.405 12.5883C10.5362 12.5883 10.6673 12.5456 10.7548 12.46L11.3669 11.8613L7.12611 7.71289L6.51404 8.31163C6.29545 8.52546 6.29545 8.82483 6.51404 9.03867L10.0553 12.46Z"
        fill="white"
      />
      <path
        d="M23.3452 15.6289L15.8256 8.27295L14.2954 9.76979L21.8151 17.1257C22.2523 17.5534 22.9518 17.5534 23.3452 17.1257C23.7387 16.7408 23.7387 16.0565 23.3452 15.6289Z"
        fill="white"
      />
      <path
        d="M12.1109 11.8183C12.242 11.9466 12.4606 11.9466 12.5918 11.8183L12.8978 11.519C13.029 11.3907 13.029 11.1768 12.8978 11.0485C12.1109 10.2787 12.5918 10.7492 7.95758 6.21585C7.82642 6.08755 7.60782 6.08755 7.47667 6.21585L7.17063 6.51522C7.03948 6.64352 7.03948 6.85736 7.17063 6.98566C8.35105 8.18313 10.8867 10.6636 12.1109 11.8183Z"
        fill="white"
      />
      <path
        d="M19.1489 19.9867H15.6077V19.9012C15.6077 19.2169 15.0393 18.6182 14.2961 18.6182H2.92917C2.22967 18.6182 1.6176 19.1741 1.6176 19.9012V19.9867H0.262314C0.131157 19.9867 0 20.115 0 20.2433C0 20.3716 0.131157 20.4999 0.262314 20.4999H19.1052C19.2364 20.4999 19.3675 20.3716 19.3675 20.2433C19.3675 20.115 19.3238 19.9867 19.1489 19.9867Z"
        fill="white"
      />
    </svg>
  )
}

export function ClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM10 0C11.3132 0 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C4.47 20 0 15.5 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0ZM10.5 5V10.25L15 12.92L14.25 14.15L9 11V5H10.5Z"
        fill="black"
      />
    </svg>
  )
}

export function TickIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="75"
      viewBox="0 0 15 75"
      fill="none"
    >
      <path
        d="M1 37.0909L5.58824 42L14 33"
        stroke="black"
        strokeLinecap="round"
      />
    </svg>
  )
}
